import React, { useEffect } from 'react'
import { useLocation,useHistory } from 'react-router-dom/cjs/react-router-dom'
const Redirecting = () => {
    let location  = useLocation()
    let history  = useHistory()

    useEffect(() => {
        history.push("/workdesk"+location.search)
    }, [location])
    
  return (
    <div>Redirecting to workdesk..</div>
  )
}

export default Redirecting